import { Messages } from '~src/codegen/Localize';

import { EdgePoolErrorCode } from '../types/EdgePoolError';
import { EdgePoolErrorContext } from '../types/EdgePoolErrorContext';

export function getErrorMessage(errorCode: EdgePoolErrorCode, context: EdgePoolErrorContext) {
  let errorMessage: string = null;
  switch (errorCode) {
    case EdgePoolErrorCode.POOL_ID_DOES_NOT_EXIST:
      errorMessage = getErrorMessageForCreatePool(context);
      break;
    case EdgePoolErrorCode.PARTIAL_DELETION:
      errorMessage = getErrorMessageForDeletePools(context);
      break;
    case EdgePoolErrorCode.AGENT_ID_DOES_NOT_EXIST:
    case EdgePoolErrorCode.INVALID_CHANGE_TYPE:
      errorMessage = getErrorMessageForUpdatePool(context);
      break;
  }

  return errorMessage ? errorMessage : Messages.bridgeSiteSettingsErrorInternal();
}

function getErrorMessageForCreatePool(context: EdgePoolErrorContext) {
  if (context.poolName) {
    return Messages.bridgeSiteSettingsErrorCreatePool({ POOL_NAME: context.poolName });
  }
  return null;
}

function getErrorMessageForDeletePools(context: EdgePoolErrorContext) {
  if (context.poolName) {
    return Messages.bridgeSiteSettingsErrorPartialDeletion({ POOL_NAME: context.poolName });
  }
  return null;
}

function getErrorMessageForUpdatePool(context: EdgePoolErrorContext) {
  if (!context.poolName && !context.domainName && context.agentName) {
    return Messages.bridgeSiteSettingsErrorUpdateClient({ CLIENT_NAME: context.agentName });
  }
  if (context.poolName && !context.domainName && !context.agentName) {
    return Messages.bridgeSiteSettingsErrorUpdatePool({ POOL_NAME: context.poolName });
  }
  if (!context.poolName && context.domainName && !context.agentName) {
    return Messages.bridgeSiteSettingsErrorUpdateDomain({ DOMAIN_NAME: context.domainName });
  }

  return null;
}
